"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Konto model module.
 * @module model/Konto
 * @version 1.0.44
 */
var Konto = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Konto</code>.
   * Kontoinformationen für einen Kunden
   * @alias module:model/Konto
   * @param nummer {String} Kontonummer
   * @param blz {String} Bankleitzahl
   * @param iban {String} Iban des Kontos 
   * @param bic {String} Bank Id Code
   * @param vorname {String} Vorname des Kontoinhabers
   * @param nachname {String} Nachname des Kontoinhabers
   * @param institutsName {String} Name der Bank
   */
  function Konto(nummer, blz, iban, bic, vorname, nachname, institutsName) {
    _classCallCheck(this, Konto);
    Konto.initialize(this, nummer, blz, iban, bic, vorname, nachname, institutsName);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Konto, null, [{
    key: "initialize",
    value: function initialize(obj, nummer, blz, iban, bic, vorname, nachname, institutsName) {
      obj['nummer'] = nummer;
      obj['blz'] = blz;
      obj['iban'] = iban;
      obj['bic'] = bic;
      obj['vorname'] = vorname;
      obj['nachname'] = nachname;
      obj['institutsName'] = institutsName;
    }

    /**
     * Constructs a <code>Konto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Konto} obj Optional instance to populate.
     * @return {module:model/Konto} The populated <code>Konto</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Konto();
        if (data.hasOwnProperty('nummer')) {
          obj['nummer'] = _ApiClient.default.convertToType(data['nummer'], 'String');
        }
        if (data.hasOwnProperty('blz')) {
          obj['blz'] = _ApiClient.default.convertToType(data['blz'], 'String');
        }
        if (data.hasOwnProperty('iban')) {
          obj['iban'] = _ApiClient.default.convertToType(data['iban'], 'String');
        }
        if (data.hasOwnProperty('bic')) {
          obj['bic'] = _ApiClient.default.convertToType(data['bic'], 'String');
        }
        if (data.hasOwnProperty('vorname')) {
          obj['vorname'] = _ApiClient.default.convertToType(data['vorname'], 'String');
        }
        if (data.hasOwnProperty('nachname')) {
          obj['nachname'] = _ApiClient.default.convertToType(data['nachname'], 'String');
        }
        if (data.hasOwnProperty('institutsName')) {
          obj['institutsName'] = _ApiClient.default.convertToType(data['institutsName'], 'String');
        }
        if (data.hasOwnProperty('kontoArt')) {
          obj['kontoArt'] = _ApiClient.default.convertToType(data['kontoArt'], 'String');
        }
        if (data.hasOwnProperty('abweichenderInhaber')) {
          obj['abweichenderInhaber'] = _ApiClient.default.convertToType(data['abweichenderInhaber'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Konto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Konto</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(Konto.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['nummer'] && !(typeof data['nummer'] === 'string' || data['nummer'] instanceof String)) {
        throw new Error("Expected the field `nummer` to be a primitive type in the JSON string but got " + data['nummer']);
      }
      // ensure the json data is a string
      if (data['blz'] && !(typeof data['blz'] === 'string' || data['blz'] instanceof String)) {
        throw new Error("Expected the field `blz` to be a primitive type in the JSON string but got " + data['blz']);
      }
      // ensure the json data is a string
      if (data['iban'] && !(typeof data['iban'] === 'string' || data['iban'] instanceof String)) {
        throw new Error("Expected the field `iban` to be a primitive type in the JSON string but got " + data['iban']);
      }
      // ensure the json data is a string
      if (data['bic'] && !(typeof data['bic'] === 'string' || data['bic'] instanceof String)) {
        throw new Error("Expected the field `bic` to be a primitive type in the JSON string but got " + data['bic']);
      }
      // ensure the json data is a string
      if (data['vorname'] && !(typeof data['vorname'] === 'string' || data['vorname'] instanceof String)) {
        throw new Error("Expected the field `vorname` to be a primitive type in the JSON string but got " + data['vorname']);
      }
      // ensure the json data is a string
      if (data['nachname'] && !(typeof data['nachname'] === 'string' || data['nachname'] instanceof String)) {
        throw new Error("Expected the field `nachname` to be a primitive type in the JSON string but got " + data['nachname']);
      }
      // ensure the json data is a string
      if (data['institutsName'] && !(typeof data['institutsName'] === 'string' || data['institutsName'] instanceof String)) {
        throw new Error("Expected the field `institutsName` to be a primitive type in the JSON string but got " + data['institutsName']);
      }
      // ensure the json data is a string
      if (data['kontoArt'] && !(typeof data['kontoArt'] === 'string' || data['kontoArt'] instanceof String)) {
        throw new Error("Expected the field `kontoArt` to be a primitive type in the JSON string but got " + data['kontoArt']);
      }
      // ensure the json data is a string
      if (data['abweichenderInhaber'] && !(typeof data['abweichenderInhaber'] === 'string' || data['abweichenderInhaber'] instanceof String)) {
        throw new Error("Expected the field `abweichenderInhaber` to be a primitive type in the JSON string but got " + data['abweichenderInhaber']);
      }
      return true;
    }
  }]);
}();
Konto.RequiredProperties = ["nummer", "blz", "iban", "bic", "vorname", "nachname", "institutsName"];

/**
 * Kontonummer
 * @member {String} nummer
 */
Konto.prototype['nummer'] = undefined;

/**
 * Bankleitzahl
 * @member {String} blz
 */
Konto.prototype['blz'] = undefined;

/**
 * Iban des Kontos 
 * @member {String} iban
 */
Konto.prototype['iban'] = undefined;

/**
 * Bank Id Code
 * @member {String} bic
 */
Konto.prototype['bic'] = undefined;

/**
 * Vorname des Kontoinhabers
 * @member {String} vorname
 */
Konto.prototype['vorname'] = undefined;

/**
 * Nachname des Kontoinhabers
 * @member {String} nachname
 */
Konto.prototype['nachname'] = undefined;

/**
 * Name der Bank
 * @member {String} institutsName
 */
Konto.prototype['institutsName'] = undefined;

/**
 * Bezeichnung der Kontoart
 * @member {String} kontoArt
 */
Konto.prototype['kontoArt'] = undefined;

/**
 * Name des Kontoinhabers, wenn er von Vorname + Nachname abweicht
 * @member {String} abweichenderInhaber
 */
Konto.prototype['abweichenderInhaber'] = undefined;
var _default = exports.default = Konto;